import { useEffect, useRef, useState } from 'react';
import { loadNewsGalleryImage } from '@/utils/newsGalleryImageCache';

export const useGalleryImage = (
  imageId: string | undefined,
  size: number | null = 500,
): string | undefined => {
  const [imageUrl, setImageUrl] = useState<string>();
  const activeUrlRef = useRef<string>(undefined);

  useEffect(() => {
    setImageUrl(undefined);

    if (!imageId) {
      return;
    }

    let canceled = false;

    const loadImage = async () => {
      const blob = await loadNewsGalleryImage(imageId, size);

      if (canceled || !blob) {
        return;
      }

      const newUrl = URL.createObjectURL(blob);

      if (activeUrlRef.current?.startsWith('blob:')) {
        URL.revokeObjectURL(activeUrlRef.current);
      }

      activeUrlRef.current = newUrl;
      setImageUrl(newUrl);
    };

    loadImage();

    return () => {
      canceled = true;
    };
  }, [imageId, size]);

  useEffect(
    () => () => {
      if (activeUrlRef.current?.startsWith('blob:')) {
        URL.revokeObjectURL(activeUrlRef.current);
      }
    },
    [],
  );

  return imageUrl;
};
